if (!customElements.get('evrayne-photo-gallery')) {
  customElements.define('evrayne-photo-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const image = this.querySelector('.ev-photo-gallery__image');
      const zoom = this.querySelector('.ev-photo-gallery__zoom');
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-photo-src]');
        if (!button || !this.contains(button)) return;
        image.src = button.dataset.photoSrc;
        image.alt = button.dataset.photoAlt;
        zoom.href = button.dataset.photoSrc;
        this.querySelectorAll('[data-photo-src]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      });
      this.dataset.ready = 'true';
    }
  });
}
